import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  Box,
  Alert
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { TarefaAntiga } from '../../services/relatorioService';

interface TarefasMaisAntigasProps {
  dados: TarefaAntiga[];
}

const TarefasMaisAntigas: React.FC<TarefasMaisAntigasProps> = ({ dados }) => {
  const obterCorDias = (dias: number): 'error' | 'warning' | 'info' => {
    if (dias > 30) return 'error';
    if (dias > 14) return 'warning';
    return 'info';
  };

  const obterCorPrioridade = (prioridade: string): 'error' | 'warning' | 'info' | 'default' => {
    switch (prioridade?.toLowerCase()) {
      case 'urgente':
        return 'error';
      case 'alta':
        return 'warning';
      case 'media':
        return 'info';
      default:
        return 'default';
    }
  };

  if (!dados || dados.length === 0) {
    return (
      <Card>
        <CardContent>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <WarningAmberIcon sx={{ mr: 1, color: 'warning.main' }} />
            <Typography variant="h6">Tarefas Mais Antigas</Typography>
          </Box>
          <Alert severity="success">
            Nenhuma tarefa antiga identificada! 🎉
          </Alert>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <WarningAmberIcon sx={{ mr: 1, color: 'warning.main' }} />
          <Typography variant="h6">⚠️ Tarefas Mais Antigas (Atenção)</Typography>
        </Box>
        
        <Alert severity="warning" sx={{ mb: 2 }}>
          <strong>Gargalos Identificados:</strong> {dados.length} tarefas abertas há muito tempo
        </Alert>

        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell><strong>Tarefa</strong></TableCell>
                <TableCell><strong>Departamento</strong></TableCell>
                <TableCell><strong>Responsável</strong></TableCell>
                <TableCell align="center"><strong>Status</strong></TableCell>
                <TableCell align="center"><strong>Prioridade</strong></TableCell>
                <TableCell align="center"><strong>Dias Aberta</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {dados.map((tarefa) => (
                <TableRow key={tarefa.id} hover>
                  <TableCell>
                    <Typography variant="body2" fontWeight="medium">
                      {tarefa.titulo}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2" color="textSecondary">
                      {tarefa.departamento}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2" color="textSecondary">
                      {tarefa.responsavel}
                    </Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Chip 
                      label={tarefa.status} 
                      size="small" 
                      variant="outlined"
                    />
                  </TableCell>
                  <TableCell align="center">
                    <Chip 
                      label={tarefa.prioridade} 
                      size="small" 
                      color={obterCorPrioridade(tarefa.prioridade)}
                    />
                  </TableCell>
                  <TableCell align="center">
                    <Chip 
                      label={`${tarefa.diasAberta} dias`}
                      size="small"
                      color={obterCorDias(tarefa.diasAberta)}
                      sx={{ fontWeight: 'bold' }}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
};

export default TarefasMaisAntigas;
